module.exports = __webpack_public_path__ + "img/up-black.1703e045.jpg";